import Link from 'src/components/ui/Link'

import Section from '../Section'
import './image-link.scss'

type TImageLink = {
  href: string
  imageSrc: string
  imageAlt: string
}

const ImageLink = ({ href, imageSrc, imageAlt }: TImageLink) => {
  return (
    <Section className="layout__section layout__content image-link-container">
      <Link className="image-link__link" href={href}>
        <img src={imageSrc} alt={imageAlt} />
      </Link>
    </Section>
  )
}

export default ImageLink
